var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3749 52.8086H18.2811C16.2647 52.8066 14.2717 52.3758 12.4345 51.5447C10.5973 50.7136 8.95792 49.5013 7.62511 47.9881C6.29229 46.475 5.29655 44.6957 4.70399 42.7683C4.11142 40.8409 3.93558 38.8095 4.18814 36.8089C4.4407 34.8084 5.11588 32.8844 6.16886 31.1648C7.22185 29.4451 8.62855 27.9691 10.2956 26.8347C11.9627 25.7003 13.8519 24.9334 15.838 24.585C17.8241 24.2365 19.8616 24.3145 21.8153 24.8138",
    stroke: "#8F9195",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 32.4961C20.3128 29.2776 21.0779 26.1053 22.5447 23.2406C24.0115 20.3759 26.138 17.9007 28.7491 16.019C31.3601 14.1373 34.3809 12.903 37.5626 12.4177C40.7442 11.9325 43.9956 12.2102 47.0488 13.2281C50.1021 14.2459 52.8698 15.9747 55.1238 18.272C57.3779 20.5692 59.0538 23.3692 60.0135 26.4413C60.9731 29.5133 61.1891 32.7694 60.6435 35.9412C60.098 39.1131 58.8065 42.1099 56.8756 44.6847",
    stroke: "#8F9195",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9756 41.1142L38.5934 32.4961L47.2112 41.1142",
    stroke: "#8F9195",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5938 52.8086V32.4961",
    stroke: "#8F9195",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUp);
export default __webpack_public_path__ + "static/media/CloudArrowUp.316e30a53ea06ac072e4040d36970f92.svg";
export { ForwardRef as ReactComponent };